module.exports = __webpack_public_path__ + "img/Chime2.96a9a4a6.jpg";